import {
  Component,
  EventEmitter,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { ConfirmationService } from './confirmation.service';
import { ModalDataType } from './modal-data-type.interface';

import { ModalService } from './modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false,
})
export class ModalComponent implements OnDestroy {
  @ViewChild('modalContainer', { static: true }) public modalContainer: ModalComponent; //'modalContainer' is the identifier #modalContainer in the template
  @ViewChild('dynamicContent', { read: ViewContainerRef, static: true })
  viewContainerRef: ViewContainerRef;

  private subscription: Subscription;
  private confirmation: ModalDataType;
  private isAccepted: boolean = false;
  private modalInstance: any;

  public display: boolean = false;
  public component: any;
  public showHeader: boolean = true;
  public header: string;
  public closeOnEscape: boolean;
  public closable: boolean;
  public styleClass: string;
  public defaultButtons: boolean;
  public acceptButton: boolean;
  public cancelButton: boolean;
  public draggable: boolean;
  public data: any;
  public maxWidth: number = 570;

  constructor(
    private _confirmationService: ConfirmationService,
    private modalService: ModalService,
  ) {
    this.subscription = _confirmationService.requireConfirmation$.subscribe(
      (confirmation) => {
        this.clearContent();

        this.confirmation = confirmation;
        this.component = confirmation.component;
        this.header = confirmation.options.header || '';
        this.showHeader = _.isUndefined(confirmation.options.showHeader)
          ? true
          : confirmation.options.showHeader;
        this.closeOnEscape = _.isUndefined(confirmation.options.closeOnEscape)
          ? true
          : confirmation.options.closeOnEscape;
        this.closable = _.isUndefined(confirmation.options.closable)
          ? true
          : confirmation.options.closable;
        this.styleClass = _.isUndefined(confirmation.options.styleClass)
          ? ''
          : confirmation.options.styleClass;
        this.draggable = _.isUndefined(confirmation.options.draggable)
          ? true
          : confirmation.options.draggable;
        this.data = _.isUndefined(confirmation.data) ? null : confirmation.data;
        this.maxWidth = _.isUndefined(confirmation.options.maxWidth)
          ? 570
          : confirmation.options.maxWidth;
        this.handleButtons(confirmation);

        this.showModal('modalContainer');

        this.confirmation.acceptEvent = new EventEmitter();
        this.confirmation.rejectEvent = new EventEmitter();

        if (this.confirmation.accept) {
          this.confirmation.acceptEvent.subscribe(this.confirmation.accept);
        }

        if (this.confirmation.reject) {
          this.confirmation.rejectEvent.subscribe(this.confirmation.reject);
        }
      },
    );
  }

  private handleButtons(confirmation: any) {
    this.acceptButton = _.isUndefined(confirmation.options.acceptButton)
      ? true
      : confirmation.options.acceptButton;
    this.cancelButton = _.isUndefined(confirmation.options.cancelButton)
      ? true
      : confirmation.options.cancelButton;
    if (this.cancelButton || this.acceptButton) {
      this.defaultButtons = true;
    }
  }

  private show(modal: ModalComponent) {
    modal.display = true;
  }

  private hide(modal: ModalComponent) {
    modal.display = false;
  }

  private clearContent() {
    this.viewContainerRef.clear();
    this.isAccepted = false;
  }

  private setOptions(modal: ModalComponent) {
    modal.header = this.header;
    modal.showHeader = this.showHeader;
    modal.closeOnEscape = this.closeOnEscape;
    modal.closable = this.closable;
    modal.styleClass = this.styleClass;
  }

  showModal(modal: string) {
    this.modalService.setRootViewContainerRef(this.viewContainerRef);
    this.modalService.addDynamicComponent(this.component);

    this.modalInstance = this[modal];
    this.setOptions(this.modalInstance);
    this.show(this.modalInstance);
  }

  sendDataFromModal(data: any, options?: any) {
    if (this.confirmation.acceptEvent) {
      this.isAccepted = true;
      this.confirmation.acceptEvent.emit(data);
    }

    if (options && options.hide) {
      this.hide(this.modalInstance);
    }
  }

  accept() {
    if (this.confirmation.acceptEvent) {
      this.confirmation.acceptEvent.emit();
    }

    this.isAccepted = true;
    this.hide(this.modalInstance);
    this.confirmation = null;
  }

  reject() {
    this.isAccepted = false;
    this.hide(this.modalInstance);
  }

  onHide() {
    if (!this.isAccepted) {
      this.confirmation.rejectEvent.emit();
      this.confirmation = null;
    }

    this.clearContent();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
